module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAclBMVEUAAAAAqv8Akv8AhfUAgPIAf+4Afe8AfvAAgPAAfO8Afu8Afu4Afe4Afe8AfO8AfO4Afu4AfO4AfO4Afe4AfO4Afe0Afe4Afe4AfO4AfO4Afe4Afe4AfO4Afe0Afe0AfO4AfO4AfO4Afe4AfO4AfO4AfO01fEQCAAAAJXRSTlMAAwcZJi4vQ0RQUVlabm97hJiapaaur8DBw8TQ0dnp7vj6+/z+8FII5AAAAHlJREFUKM/F0kcOgDAMBEB67713/v9FMEpu3hNI+Dqys1JWUb6Y6BRjM5hJ1BnshM3c2WkjOtaafdQizEGigDAGmBC6ACtCA+B426Lypu039mDxCVsA9H8KO4BF811YD2CJwzbPT5/bxOEsOtIypstypQw6EsNPWn4BynwUq8sv3MYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/qx-2@2x.png
// module id = 7Isn
// module chunks = 96